/**
 * @file General Queue Actions.
 */
export const QUEUE_EXTEND_LEASES = 'queue/QUEUE_EXTEND_LEASES';
export const QUEUE_DROP_LEASES = 'queue/QUEUE_DROP_LEASES';

export const extendLeasesSuccess = leases => ({
  type: QUEUE_EXTEND_LEASES,
  leases,
});

export const dropLeasesSuccess = leaseIds => ({
  type: QUEUE_DROP_LEASES,
  leaseIds,
});

/**
 * Extends leases.
 *
 * @param {Array<Object>} leases - The leases with lease ids and times to extend (in seconds).
 * @param {Function} extendLease - The extendLease mutation.
 * @returns {Function} - The action.
 */
export const extendLeases = (leases, extendLease) => async dispatch => {
  const requests = leases
    .filter(lease => lease.leaseId)
    .map(lease => extendLease(lease.leaseId, lease.time));

  const responses = await Promise.all(requests);
  const newLeases = responses.map(response => ({
    leaseId: response.data.extendLease.lease_id,
    time: response.data.extendLease.lease_expires_at,
  }));

  dispatch(extendLeasesSuccess(newLeases));
};

/**
 * Drops leases.
 *
 * @param {Array<string>} leaseIds - The lease ids to drop.
 * @param {Function} dropLease - The dropLease mutation.
 * @returns {Function} - The action.
 */
export const dropLeases = (leaseIds, dropLease) => async dispatch => {
  // Drop the leases immediately without waiting for a response.
  dispatch(dropLeasesSuccess(leaseIds));

  const requests = leaseIds.filter(Boolean).map(leaseId => dropLease(leaseId));
  Promise.all(requests);
};
